import { Container } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import React, { useEffect, useMemo, useState } from "react";
import Footer from "../common/Footer";
import Header from "../common/Header";
import "../css/Evaluationcomparison.css";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getEvaluationDiff } from "../../redux/actions/evaluationConfirm";
import { PRINTING_RESET, print } from "../../redux/actions/printing";
import { PRIORITY_TARGET_CHECK_RESET, checkPriorityTarget, saveTarget } from "../../redux/actions/planningSheet";
import { BsArrowsFullscreen } from "react-icons/bs";

export default function Evaluationcomparison() {
  const [selectedItems, setSelectedItems] = useState([]); // [{ image, itemId, currentGrading }]
  const [searchParams] = useSearchParams();
  const [message, setMessage] = useState("");
  const user = useSelector(state => state.auth.user);
  const serialNumber = user ? user.student.serialNumber : "";
  const grade = user ? user.student.grade : "";
  const classNumber = user ? user.student.classNumber : "";
  const number = user ? user.student.number : "";
  const name = user ? user.student.name : "";
  const gradeRange = useSelector(state => state.evaluationConfirm.gradeRange);
  const evaluationDiffList = useSelector(state => state.evaluationConfirm.evaluationDiffList);
  const downloadLink = useSelector(state => state.printing.downloadLink);
  const confirmSaveCheck = useSelector(state => state.planningSheet.confirmSaveCheck);
  const termId = searchParams.get("termId");
  const listId = searchParams.get("listId");

  const columnWidth  = useMemo(() => 100/(gradeRange.end - gradeRange.start + 1), [gradeRange])

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getEvaluationDiff({ termId, listId }));
  }, [dispatch]);

  useEffect(() => {
    if (downloadLink) {
      window.open(`/neqst${downloadLink}`, "_blank");
      dispatch({ type: PRINTING_RESET });
    }
  }, [downloadLink]);

  const handleImageClickModal = (image, itemId, currentGrading) => {
    if (selectedItems.length < 3) {
      // Only check itemId to avoid duplicates (itemId is unique, image can repeat)
      if (!selectedItems.some(item => item.itemId === itemId)) {
        console.log(selectedItems);
        const selectedCard = selectedItems;
        selectedCard.push({ image, itemId, currentGrading });
        setSelectedItems(selectedCard);
        
        const clickedCard = document.querySelector(`[src="${image}"]`);
        clickedCard.classList.add("clicked");

        // 0.5秒後にclickedクラスを削除して元のサイズに戻す
        setTimeout(() => {
          clickedCard.classList.remove("clicked");
        }, 200);
      }
    }
  };

  const handleImageClick = (image, itemId, currentGrading) => {
    if (selectedItems.length < 3) {
      // Only check itemId to avoid duplicates (itemId is unique, image can repeat)
      if (!selectedItems.some(item => item.itemId === itemId)) {
        setSelectedItems(prevSelected => [...prevSelected, { image, itemId, currentGrading }]);
        
        const clickedCard = document.querySelector(`[src="${image}"]`);
        clickedCard.classList.add("clicked");

        // 0.5秒後にclickedクラスを削除して元のサイズに戻す
        setTimeout(() => {
          clickedCard.classList.remove("clicked");
        }, 200);
      }
    }
  };

  const handleImageRemove = itemId => {
    setSelectedItems(prevSelected => prevSelected.filter(item => item.itemId !== itemId));
  };

  const handleClearImages = () => {
    setSelectedItems([]);
  };

  useEffect(() => {
    if (confirmSaveCheck) {
      sendSelfPriorityTarget();
    }
  }, [confirmSaveCheck]);

  const sendSelfPriorityTarget = () => {
    if (selectedItems.length !== 0) {
      const rows = selectedItems.map(item => ({
        serialNumber: serialNumber,
        grade: grade,
        classNumber: classNumber,
        number: number,
        name: name,
        termId: searchParams.get("termId"),
        listId: searchParams.get("listId"),
        itemId: item.itemId,
        currentGrading: item.currentGrading,
        targetGrading: "",
        approachScene: "",
        howToApproach: ""
      }));

      dispatch(saveTarget({ listId, termId, rows }));
      setMessage(`${selectedItems.length}個重点目標を登録できました`);
      // チェックメッセージをリセットする
      dispatch({ type: PRIORITY_TARGET_CHECK_RESET });
    } else {
      // データがない場合にエラーメッセージを表示
      setMessage("重点目標を選択してください");
      dispatch({ type: PRIORITY_TARGET_CHECK_RESET });
    }
  };

  const handleSendButtonClick = () => {
    dispatch(checkPriorityTarget({ listId, termId }));
  };

  const handleSelfEvaluationButton = () => {
    window.location.href = `/Evaluation?listId=${listId}&termId=${termId}`;
  };

  const handleOtherEvaluationButton = () => {
    window.location.href = `/Evaluation?isOther=${true}&listId=${listId}&termId=${termId}`;
  };

  const handlePlanningSheetButton = () => {
    window.location.href = `/PlaningSheet?listId=${listId}&termId=${termId}`;
  };

  const handleBackButton = () => {
    window.location.href = `/EvaluationConfirm?listId=${listId}&termId=${termId}`;
  };

  const handlePrintButton = () => {
    const request = {
      printTarget: 3,
      termId,
      listId,
      students: [
        {
          serialNumber: user.student.serialNumber,
          grade: user.student.grade
        }
      ]
    };
    dispatch(print(request));
  };

  const [fullscreenContent, setFullscreenContent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleFullscreen = (stickerLevel, level, levelMap) => () => {
    const content = (
      <div className="fullscreen-display" style={{ marginTop: "30px" }}>
        {levelMap && levelMap[stickerLevel]
          ? levelMap[stickerLevel].map(data => (
              <div
                key={data.itemId}
                className="card-comparison-modal"
                onClick={() => handleImageClickModal(`/neqst/images/${listId}/${data.fileName}`, data.itemId, level)}
              >
                <img src={`/neqst/images/${listId}/${data.fileName}`} className="compare-image" />
              </div>
            ))
          : null}
      </div>
    );
    setFullscreenContent(content);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  };

  const closeFullscreen = () => {
    setFullscreenContent(null);
    setIsModalOpen(false);
    document.body.style.overflow = "auto";
  };

  const evaluationComparison = (stickerLevel, level, levelMap, backColor) => {
    return (
      <div className="div-evaluation-4" style={{ backgroundColor: backColor, width:`${columnWidth}%` }}>
        {levelMap && levelMap[stickerLevel]
          ? levelMap[stickerLevel].map((data, index) => {
              if (index < 8) {
                return (
                  <div
                    key={data.itemId}
                    className="card-comparison"
                    onClick={() => handleImageClick(`/neqst/images/${listId}/${data.fileName}`, data.itemId, level)}
                  >
                    <img src={`/neqst/images/${listId}/${data.fileName}`} className="compare-image" />
                  </div>
                );
              } else {
                return null;
              }
            })
          : null}
        {levelMap && levelMap[stickerLevel] && levelMap[stickerLevel].length >= 8
          ? <BsArrowsFullscreen
              onClick={toggleFullscreen(stickerLevel, level, levelMap)}
              style={{
                position: "relative",
                alignSelf: "flex-end",
                cursor: "pointer"
              }}
            />
          : null}
      </div>
    );
  };

  const grades = gradeRange
    ? Array.from({ length: gradeRange.end - gradeRange.start + 1 }, (_, i) => {
        const gradeNum = gradeRange.start + i;
        return ["S", "A", "B", "C", "D", "E"][gradeNum - 1];
      }).filter(grade => grade)
    : ["S", "A", "B", "C", "D", "E"];
  const stickerLevels = gradeRange
    ? Array.from({ length: gradeRange.end - gradeRange.start + 1 }, (_, i) => {
        const gradeNum = gradeRange.start + i;
        return String(gradeNum).padStart(2, "0");
      })
    : ["01", "02", "03", "04", "05", "06"];

  const backColors = {
    "01": ["#FFFFFF", "#E3E9F5", "#B8CCE4", "#95B3D7", "#366092", "#244061"],
    "02": ["#FFFCF3", "#FFFFFF", "#E3E9F5", "#B8CCE4", "#95B3D7", "#366092"],
    "03": ["#FFF2CC", "#FFFCF3", "#FFFFFF", "#E3E9F5", "#B8CCE4", "#95B3D7"],
    "04": ["#FFE699", "#FFF2CC", "#FFFCF3", "#FFFFFF", "#E3E9F5", "#B8CCE4"],
    "05": ["#FFD966", "#FFE699", "#FFF2CC", "#FFFCF3", "#FFFFFF", "#E3E9F5"],
    "06": ["#FFC000", "#FFD966", "#FFE699", "#FFF2CC", "#FFFCF3", "#FFFFFF"]
  };

  return (
    <Box>
      {isModalOpen && (
        <div>
          <div className="modal-overlay" />
          <div className="modal">
            <div className="modal-content">
              <Button
                variant="contained"
                size="medium"
                onClick={closeFullscreen}
                sx={{
                  bgcolor: "#82b1ff",
                  marginLeft: "auto",
                  marginRight: "10px",
                  marginBottom: "20px",
                  position: "absolute",
                  top: "10px",
                  right: "10px"
                }}
              >
                画面を閉じる
              </Button>
              {fullscreenContent}
            </div>
          </div>
        </div>
      )}
      <Header />
      <Box sx={{ m: 1, alignItems: "center", justifyContent: "center" }}>
        <Typography component="h3" variant="h7">
          自己評価と他者評価の違いをチェック
        </Typography>
      </Box>
      <Container>
        <Grid container spacing={2}>
          <FormControl fullWidth sx={{ ml: 9, mt: 1 }}>
            <Typography component="h5" variant="h6" align="left">
              {user ? `${user.student.grade}年${user.student.classNumber}組　${user.student.name}` : null}
            </Typography>
          </FormControl>
          <Grid item xs={12}>
            <div className="container2">
              <div className="div-evaluation-1" />
              {grades.map((grade, index) => (
                <div className="div-evaluation-2" style={{width:`${columnWidth}%`}} key={index}>
                  {grade}
                </div>
              ))}
            </div>
            {grades.map((rowGrade, rowIndex) => {
              const rowStickerLevel = String(rowIndex + 1).padStart(2, "0");
              const levelMap = evaluationDiffList[`level${rowGrade}Map`];
              return (
                <div className="container2" key={rowIndex}>
                  <div className="div-evaluation-3">{rowGrade}</div>
                  {stickerLevels.map((stickerLevel, colIndex) => (
                    <React.Fragment key={colIndex}>
                      {evaluationComparison(
                        stickerLevel,
                        rowStickerLevel,
                        levelMap,
                        backColors[rowStickerLevel][colIndex]
                      )}
                    </React.Fragment>
                  ))}
                </div>
              );
            })}
          </Grid>
        </Grid>
        <Grid item xs={3}>
          <Box
            maxWidth="md"
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "left",
              maxWidth: "75%"
            }}
          >
            <Button
              variant="contained"
              size="medium"
              onClick={handleSelfEvaluationButton}
              fullWidth
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5, width: "80%" }}
            >
              自己評価（あなた自身が考えるあなた）
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handleOtherEvaluationButton}
              fullWidth
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", marginRight: 5 }}
            >
              他者評価を見る（ほかの人から見たあなた）
            </Button>
            <Button
              variant="contained"
              size="medium"
              onClick={handlePlanningSheetButton}
              fullWidth
              sx={{ bgcolor: "#82b1ff", mt: 2, fontSize: "15px", padding: "20px 0px" }}
            >
              現在の重点目標を見る
            </Button>
          </Box>
        </Grid>
        <FormControl fullWidth sx={{ ml: 7, mt: 3 }}>
          <Typography component="h5" variant="h6" align="left">
            ３つの重点目標を選ぼう！
            <div className="div-plan-8">{message}</div>
          </Typography>
        </FormControl>
        <Grid container>
          <Box
            maxWidth="md"
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              width: "75%",
              maxWidth: "76%",
              marginLeft: "68px",
              marginTop: "7px"
            }}
          >
            <Grid item xs lg={7} marginTop={3} marginRight={2}>
              <div className="div-4" style={{ display: "flex", flexDirection: "row", paddingTop: 16 }}>
                {Array.isArray(selectedItems) &&
                  selectedItems.map((item, index) => (
                    <React.Fragment key={item.itemId}>
                      <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                        <div
                          style={{ width: "127px", height: "180px" }}
                          className="cards"
                          onClick={() => handleImageRemove(item.itemId)}
                        >
                          <img src={item.image} width="100%" height="100%" />
                        </div>
                        <Typography variant="h7" align="center" paddingTop={1} paddingBottom={1}>
                          {index === 0 && "1枚目"}
                          {index === 1 && "2枚目"}
                          {index === 2 && "3枚目"}
                        </Typography>
                      </div>
                    </React.Fragment>
                  ))}
              </div>
            </Grid>
            <Grid item xs={2}>
              <FormControl sx={{ mt: 5 }}>
                <Button
                  variant="contained"
                  onClick={handleClearImages}
                  sx={{ bgcolor: "#82b1ff", padding: "15px 12px" }}
                >
                  現在のカードをクリア
                </Button>
              </FormControl>
              <FormControl sx={{ mt: 5 }}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleSendButtonClick}
                  sx={{ bgcolor: "#82b1ff", padding: "15px 50px" }}
                >
                  これに<br />決定！
                </Button>
              </FormControl>
            </Grid>
          </Box>
        </Grid>
        <Box
          maxWidth="md"
          sx={{
            display: "flex",
            mt: 5,
            flexDirection: "row",
            maxWidth: "76%"
          }}
        >
          <Button
            variant="contained"
            size="medium"
            onClick={handlePrintButton}
            sx={{ bgcolor: "#82b1ff", marginRight: "auto" }}
          >
            印刷
          </Button>
          <Button
            variant="contained"
            size="medium"
            onClick={handleBackButton}
            sx={{ bgcolor: "#82b1ff", marginLeft: "auto", marginRight: "10px" }}
          >
            戻る
          </Button>
        </Box>
      </Container>
      <Footer />
    </Box>
  );
}